/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { notification, Modal } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";

// import logoImage from "../../../assets/images/logo.png";
import { Link } from "react-router-dom";
import Storage from "./../../../services/local-store";
import networkList from "./../../../constants/networkList";
import postService from "./../../../services/httpService";
import Select2 from "./../../../components/FormComponent/select2";
import moment from "moment";
// import menuList from './../../../constants/menu';
import { NavContext, PropContext } from "./../../body/propContext";

import hospitalIcon from "../../../assets/images/Bitmap.png";
import dashboardIcon from "../../../assets/images/Dashboard.svg";
import tokenGeneratorIcon from "../../../assets/images/TokenGenerator.svg";
import operatorIcon from "../../../assets/images/Operator.svg";
import doctorIcon from "../../../assets/images/Doctor.svg";
import reportsIcon from "../../../assets/images/Reports.svg";
import reportIcon from "../../../assets/images/Report.svg";
import profileIcon from "../../../assets/images/Oval.png";
import serviceIcon from "../../../assets/images/service.svg";
import Multiple_units_switch from "../../../common/page/multiple_units_switch";
import { DownOutlined } from '@ant-design/icons';

const { } = networkList;
class Navigation extends Component {
  constructor(props) {
    super(props);
    this.timeoutTime = 0;
    this.state = {
      date: new Date(),
      menuList: [],
      userData: {},
      visible: false,
      u_data:"units_data",
    };
    this.logout = this.logout.bind(this, true);
  }

  componentDidMount() {
    let userData = localStorage.getItem("user_data");
    if (userData !== null) {
      userData = JSON.parse(userData);
      this.setState((state) => ({ userData: userData }));
    }

    this.fetchMenu();
    this.setup();
  }
  showProfile = () => {
    this.props.history.push(`/profile`);
  };
  fetchMenu() {
    const { getRolePermissions } = networkList;

    postService(getRolePermissions, "GET", null).then((res) => {
      // console.log("getRolePermissions", res);
      if (res.status) {
        this.props.menuData(res.data);
        this.setState((state) => ({ menuList: res.data }));
      }
    });
  }
  clearAll() {
    Storage.clearAll();
    this.props.history.push(`/login`);
  }

  setup() {
    const { id, slug } = this.props.match.params;

    if (id !== "tv-display" && id !== "" && id !== "/") {
      window.addEventListener("mousemove", () => this.resetTimer(), false);
      window.addEventListener("mousedown", () => this.resetTimer(), false);
      window.addEventListener("keypress", () => this.resetTimer(), false);
      window.addEventListener("DOMMouseScroll", () => this.resetTimer(), false);
      window.addEventListener("mousewheel", () => this.resetTimer(), false);
      window.addEventListener("touchmove", () => this.resetTimer(), false);
      window.addEventListener("MSPointerMove", () => this.resetTimer(), false);
      this.startTimer();
    }
  }

  startTimer() {
    this.timeoutTime = moment();
    // console.log('timmer Start', moment().format('HH:mm s'));
    this.timeoutID = window.setInterval(() => this.goInactive(), 60000);
  }

  resetTimer(e) {
    // console.log('timmer reset', moment().format('HH:mm s'));
    this.timeoutTime = 0;
    window.clearInterval(this.timeoutID);
    this.goActive();
  }

  goInactive() {
    let timeDiff = moment.duration(moment().diff(this.timeoutTime)).minutes();

    // console.log('timmer inactive', timeDiff);
    let This = this;
    if (timeDiff === 56) {
      Modal.destroyAll();
      Modal.confirm({
        title: "Inactive Session. Your session is no longer active",
        icon: <ExclamationCircleOutlined />,
        content: `You will Auto Logout in next 3min`,
        okText: "Stay signed in",
        okType: "primary",
        cancelText: "Logout",
        cancelType: "danger",
        onOk() {
          This.resetTimer();
        },
        onCancel() {
          window.clearTimeout(This.timeoutID);
          This.logout();
        },
      });
    }

    if (timeDiff === 59) {
      Modal.destroyAll();
      // console.log('timmer inactive', timeDiff);
      window.clearTimeout(this.timeoutID);
      this.logout();
    }
  }

  goActive() {
    this.startTimer();
  }

  logout() {
    const { logout } = networkList;
    const id = JSON.parse(Storage.get("id"));
    Modal.destroyAll();
    // let data={
    //     "id": id,
    // }
    // console.log('data', data)
    this.setState({
      id: id,
    });
    try {
      this.setState(
        (state) => ({ btnloading: true }),
        () => {
          postService(logout, "GET", {
            id: this.state.id,
          }).then((res) => {
            if (res.status) {
              // alert('Data inserted');
              // console.log('res', res)
              // this.setState((state) => ({ btnloading: false, visible: false }));
              // Modal.success({
              //     title: 'Success',
              //     content: "Successfully Updated",
              // });
              // notification.success({
              //     message: 'Success',
              //     description: res.message,
              //     duration: 3,
              //     top: 20,
              //     right: 0
              // });
            } else {
              // alert('Data not inserted');
              // this.setState({btnloading:false})
              // Modal.error({
              //     title: 'Failure',
              //     content: res.message? res.message:'Oops! something went wrong... Please try again.',
              // });
              // notification.error({
              //     message: 'Failure',
              //     description: res.message? res.message:'Oops! something went wrong... Please try again.',
              //     duration: 3,
              //     top: 20,
              //     right: 0
              // });
            }
            this.clearAll();
          });
        }
      );
    } catch (error) {
   
      Modal.error({
        title: "Failure",
        content: "Oops, something went wrong... Please try again.",
      });
    }
  }
  getImage = (text) => {
    return text === "Dashboard"
      ? dashboardIcon
      : text === "Queue"
        ? tokenGeneratorIcon
        : text === "TAT Reports"
          ? reportIcon
          : text === "Reports"
          ? reportIcon
          : text === "MIS"
          ? reportsIcon
          : serviceIcon;
  };
  returnBadge = () => {
    return (
      <>
        {/* {networkList.base_url !== "https://qms.rainbowhospitals.in:3000/" && ( */}
        {networkList.base_url !== "http://localhost:3001/" && (
          <span className="badge">
            UAT
          </span>
        )}
      </>
    );
  }

  render() {
    let { id } = this.props.match.params;
    const { menuList, userData } = this.state;
    menuList.sort(function (a, b) {
      return a.menu_order - b.menu_order;
    });
    return (
     
      <PropContext.Provider value={{ menuList: this.state.menuList }}>
       
        <header>
          <div className="navBar" >
            <div className="row">
              {/* hospital logo */}
              <div className="col-2"  >
                <div className="hospitalicon" >
                  {this.returnBadge()}
                  <img alt="" src={hospitalIcon} width="100px" height="35px" />
                  {/* <NavContext.Consumer>
                    {({ currentUnitPlace }) => (
                      <h6 className="ml-1" style={{ color: "#6c3964" }}>
                        {currentUnitPlace}
                      </h6>
                    )}
                  </NavContext.Consumer> */}
                  {/* width: 30px;
                  position: absolute;
                  top: 7px;
                  right: -1px; */}
                 
                  <div className='row m-0' style={{ position: 'fixed', top: '39px',   left: '-30px', zIndex: 4, width: '15%', transform: 'scale(0.6)',fontSize:'64px' }}>
                    
           
    
                    <Multiple_units_switch {...this.state} {...this.props}/>

                  </div>
                </div>
              </div>
              {/* dynamic menu */}
              <div className="col-10" >
                <div className="menu-List">
                  {(id === undefined || id !== undefined) &&
                    id !== "tv-display" && (
                      <ul className="row list-inline">
                        <div className="col-10">
                          {menuList.map((menu, key) => {
                       
                            if (menu.submenu.length === 0) {
                              if (menu.permissions["view"] === "true") {
                                return (
                                  <li className="list-inline-item" key={key}>
                                    <div className="row">
                                      <Link to={`/${menu.route}`}>
                                        {/* <img
                                          src={`/assets/images/${menu.icon}`}
                                          alt=""
                                        /> */}
                                        <img
                                          className="menuIcon"
                                          src={this.getImage(menu.text)}
                                          alt=""
                                        />
                                        {menu.text}
                                      </Link>
                                      {menuList.length !== key + 1 && (
                                        <div class="navDivider" />
                                      )}
                                    </div>
                                  </li>
                                );
                              }
                            }
                            if (menu.submenu.length !== 0) {
                              return (
                                <li
                                  className="list-inline-item dropdown"
                                  key={key}
                                >
                                  <div className="row" >
                                    <a
                                      className="dropdown-toggle"
                                      // href="javascript:void(0);"
                                      href="#"
                                      role="button"
                                      id={`dropdownMenuLink${key}`}
                                      data-toggle="dropdown"
                                      aria-haspopup="true"
                                      aria-expanded="false"
                                    >
                                      {/* <img
                                        src={`/assets/images/icons/${menu.icon}`}
                                        alt=""
                                      /> */}
                                      <img
                                        className="menuIcon"
                                        src={this.getImage(menu.text)}
                                        alt=""
                                      />
                                      {menu.text}
                                      {/* <Icon
                                        type="down"
                                        style={{
                                          verticalAlign: "baseline",
                                          fontSize: "12px",
                                          marginLeft: "5px",
                                        }}
                                      /> */}
                                     

<DownOutlined
  style={{
    verticalAlign: 'baseline',
    fontSize: '12px',
    marginLeft: '5px',
  }}
/>

                                    </a>
                                    <div
                                      className="dropdown-menu"
                                      aria-labelledby={`dropdownMenuLink${key}`}
                                      
                                    >
                                      {menu.submenu.map((submenu, skey) => {
                                        if (
                                          submenu.permissions["view"] === "true"
                                        ) {
                                          return (
                                            <Link
                                              key={skey}
                                              className="dropdown-item"
                                              to={`/${menu.route}/${submenu.route}`}
                                              
                                            >
                                              {submenu.text}
                                            </Link>
                                          );
                                        }
                                      })}
                                    </div>
                                    {menuList.length !== key + 1 && (
                                      <div class="navDivider" />
                                    )}
                                  </div>
                                </li>
                              );
                            }
                          })}
                        </div>
                        <div className="col-2 p-0 text-right" >
                          <li className="list-inline-item">
                            <a
                              href="javascript:void(0)"
                              className="dropdown-toggle pb-4"
                              role="button"
                              id="dropdownMenuLink3"
                              data-toggle="dropdown"
                              aria-haspopup="true"
                              aria-expanded="false"
                            >
                              {/* <img alt="" src={profileIcon} /> */}
                              <img
                                alt=""
                                src="/assets/images/newProfile.png"
                                style={{ borderRadius: "50%" }}
                              />
                              {JSON.parse(Storage.get("user"))}
                              {/* <Icon
                                type="down"
                                style={{
                                  verticalAlign: "baseline",
                                  fontSize: "12px",
                                  marginLeft: "10px",
                                }}
                              /> */}
                            

<DownOutlined
  style={{
    verticalAlign: 'baseline',
    fontSize: '12px',
    marginLeft: '10px',
  }}
/>

                              <small className="nav-info">
                                ({JSON.parse(Storage.get("role"))})
                              </small>
                            </a>
                            <div
                              className="dropdown-menu animate slideIn"
                              aria-labelledby="dropdownMenuLink3"
                            >
                              <a
                                href="javascript:void(0)"
                                className="dropdown-item"
                                onClick={this.showProfile}
                              >
                                Profile
                              </a>
                              <a
                                href="javascript:void(0)"
                                className="dropdown-item"
                                onClick={this.logout}
                              >
                                Logout
                              </a>
                            </div>
                          </li>
                        </div>
                      </ul>
                    )}
                </div>
              </div>
              {/* profile dropdown */}
              {/* <div className="col-lg-2 col-md-4 col-sm-1 menu-List pl-5">
                <ul className="list-inline">
                  <li className="list-inline-item">
                    <a
                      href="javascript:void(0)"
                      className="dropdown-toggle pb-4"
                      role="button"
                      id="dropdownMenuLink3"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <img alt="" src={profileIcon} />
                      {JSON.parse(Storage.get("user"))}
                      <Icon
                        type="down"
                        style={{
                          color: "#fff",
                          verticalAlign: "baseline",
                          fontSize: "12px",
                        }}
                      />
                      <small className="nav-info">
                        ({JSON.parse(Storage.get("role"))})
                      </small>
                    </a>
                    <div
                      className="dropdown-menu animate slideIn"
                      aria-labelledby="dropdownMenuLink3"
                    >
                      <a
                        href="javascript:void(0)"
                        className="dropdown-item"
                        onClick={this.showProfile}
                      >
                        Profile
                      </a>
                      <a
                        href="javascript:void(0)"
                        className="dropdown-item"
                        onClick={this.logout}
                      >
                        Logout
                      </a>
                    </div>
                  </li>
                </ul>
              </div> */}
            </div>
          </div>
        </header>
      </PropContext.Provider>
    );
  }
}

export default Navigation;
